import type { ReactNode } from "react";

import { t } from "../../lib/i18n";

import "./ui.css";

interface LoadingStateProps {
  titleKey?: string;
  message?: ReactNode;
}

export function LoadingState({ titleKey = "states.loadingTitle", message }: LoadingStateProps) {
  return (
    <div className="state state--loading">
      <div className="state__spinner" aria-hidden="true" />
      <p className="state__title">{t(titleKey)}</p>
      {message && <p className="state__body">{message}</p>}
    </div>
  );
}

interface EmptyStateProps {
  titleKey?: string;
  bodyKey?: string;
  action?: ReactNode;
}

export function EmptyState({
  titleKey = "states.emptyTitle",
  bodyKey = "states.emptyBody",
  action,
}: EmptyStateProps) {
  return (
    <div className="state state--empty">
      <p className="state__title">{t(titleKey)}</p>
      <p className="state__body">{t(bodyKey)}</p>
      {action && <div className="state__action">{action}</div>}
    </div>
  );
}

interface ErrorStateProps {
  titleKey?: string;
  bodyKey?: string;
  message?: ReactNode;
  action?: ReactNode;
}

export function ErrorState({
  titleKey = "states.errorTitle",
  bodyKey,
  message,
  action,
}: ErrorStateProps) {
  return (
    <div className="state state--error">
      <p className="state__title">{t(titleKey)}</p>
      {bodyKey && <p className="state__body">{t(bodyKey)}</p>}
      {message && <p className="state__body">{message}</p>}
      {action && <div className="state__action">{action}</div>}
    </div>
  );
}
